var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.66667C23.364 2.66667 29.3333 8.63734 29.3333 16C29.3333 23.3627 23.364 29.3333 16 29.3333C8.63599 29.3333 2.66666 23.3627 2.66666 16C2.66666 8.63734 8.63599 2.66667 16 2.66667ZM16.0024 20.0049C15.2671 20.0049 14.6708 20.6011 14.6708 21.3365C14.6708 22.0719 15.2671 22.668 16.0024 22.668C16.7377 22.668 17.334 22.0719 17.334 21.3365C17.334 20.6011 16.7377 20.0049 16.0024 20.0049ZM15.9995 9.33334C15.3157 9.33358 14.7524 9.84851 14.6756 10.5117L14.6667 10.6672L14.6691 17.3349L14.6781 17.4905C14.7553 18.1536 15.3191 18.6681 16.0029 18.6679C16.6867 18.6676 17.25 18.1527 17.3268 17.4895L17.3357 17.334L17.3333 10.6662L17.3243 10.5107C17.2471 9.8476 16.6833 9.3331 15.9995 9.33334Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.efe9db837e3e432938185e9895eb98f0.svg";
export { ForwardRef as ReactComponent };